import { type PaymentIntent } from "@common/components/Form/Field/StripeCard/lib";
import { type FormComponentBaseProps } from "@common/controls/Form/Field/component";
import CreditCardInputBase, { type CreditCardInfo } from "@common/controls/Inputs/CreditCard/component";
import React from "react";

export type CreditCardInputProps = FormComponentBaseProps & {
  createPaymentIntent: (value: CreditCardInfo) => Promise<PaymentIntent>;
  onChange?: (value: CreditCardInfo) => void;
};

const CreditCardInput = React.forwardRef((props: CreditCardInputProps, ref: React.RefObject<any>) => {
  const [creditCardInfo, setCreditCardInfo] = React.useState<CreditCardInfo | null>(null);

  React.useImperativeHandle(
    ref,
    () => ({
      getFinalValue: async () => {
        const si = await props.createPaymentIntent(creditCardInfo!);
        return si.id;
      }
    }),
    [props.createPaymentIntent, creditCardInfo]
  );

  const onChange = React.useCallback(
    (value: CreditCardInfo) => {
      setCreditCardInfo(value);
      props.onChange && props.onChange(value);
    },
    [props.onChange]
  );

  return <CreditCardInputBase onChange={onChange} style={props.style} value={creditCardInfo} />;
});
export default CreditCardInput;
